export const OPEN_MENU = 'FLOATING_NAV.OPEN_MENU';
export const OPEN_RIGHT = 'FLOATING_NAV.OPEN_RIGHT';
export const RESET = 'FLOATING_NAV.RESET';

const SET_BETSLIP_BETS_NUMBER = 'SET_BETSLIP_BETS_NUMBER';
const SET_CASHOUT_BETS_NUMBER = 'SET_CASHOUT_BETS_NUMBER';
const SET_BETSLIP_TOOLTIP = 'SET_BETSLIP_TOOLTIP';

export const reset = () => ({
  type: RESET,
});

export const openMenu = () => ({
  type: OPEN_MENU,
});

export const openRight = () => ({
  type: OPEN_RIGHT,
});

export const setBetslipBetsNumber = (betslipbBetsNumber) => ({
  type: SET_BETSLIP_BETS_NUMBER,
  betslipbBetsNumber,
});

export const setBetslipTooltip = (betslipbTooltip) => ({
  type: SET_BETSLIP_TOOLTIP,
  betslipbTooltip,
});

export const setCashoutBetsNumber = (cashoutBetsNumber) => ({
  type: SET_CASHOUT_BETS_NUMBER,
  cashoutBetsNumber,
});

const panelInitialState = {
  stateLeftPanel: false,
  stateRightPanel: false,
};

export const initialState = {
  ...panelInitialState,
  betslipbBetsNumber: 0,
  cashoutBetsNumber: 0,
  betslipbTooltip: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return {
        ...state,
        ...panelInitialState,
      };
    case OPEN_MENU:
      return {
        ...state,
        stateLeftPanel: !state.stateLeftPanel,
      };
    case OPEN_RIGHT:
      return {
        ...state,
        stateRightPanel: !state.stateRightPanel,
      };
    case SET_BETSLIP_BETS_NUMBER:
      return {
        ...state,
        betslipbBetsNumber: action.betslipbBetsNumber,
      };
    case SET_BETSLIP_TOOLTIP:
      return {
        ...state,
        betslipbTooltip: action.betslipbTooltip,
      };
    case SET_CASHOUT_BETS_NUMBER:
      return {
        ...state,
        cashoutBetsNumber: action.cashoutBetsNumber,
      };
    default:
      return state;
  }
};
